exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".catalog-vendor-list .catalog-item-discontinued,.catalog-vendor-list .catalog-item-discontinued a,.catalog-vendor-list .catalog-item.discontinued,.catalog-vendor-list .catalog-item.discontinued a,.catalog-vendor-list .unit.legacy{color:#b2b2b2}", ""]);

// exports
